const __WEBPACK_NAMESPACE_OBJECT__ = window["oidc-client-ts"];